import Request from '../../services/Requests.js'
import * as types from '../mutation-types'
import _ from 'lodash'

// state
export const state = {
    all: [],
    getGymById: {},
    getNewGym: {},
    searchedGym: ''
};

// mutations
export const mutations = {
    [types.ADD_GYMS] (state, gyms) {
        state.all = gyms;
    },

    [types.ADD_GYM] (state, { gym }) {
        const aGym = _.head(gym.data);
        state.all.push(aGym);
        state.getNewGym = aGym;
        // state.all.push(gym);
        // state.getNewGym = gym;
    },

    [types.UPDATE_GYM] (state, { gym }) {
        let aGym = _.head(gym.data),
            index = _.findIndex(state.all, function (item) { return item.id === aGym.id });
        // let index = _.findIndex(state.all, function (item) { return item.id === gym.id });
        state.all[index] = aGym;
        state.getNewGym = aGym;
    },

    [types.DELETE_GYM] (state, gym) {
        if (_.isObject(gym)) {
            let index = _.findIndex(state.all, function(item) {
                return item.id === gym.id;
            });
            if (index >= 0) {
                state.all.splice(index, 1);
            }
        }
    },

    [types.ADD_GYM_BY_ID] (state, gym) {
        state.getGymById = gym;
    },

    [types.CHECKING_GYM_NAME] (state, data) {
        state.searchedGym = '';
        if (_.isObject(data)) {
            state.searchedGym = 'fa-times red';
        } else {
            state.searchedGym = 'fa-check green';
        }
    }
};

// actions
export const actions = {
    saveGym ({ commit }, data) {
        commit(types.ADD_GYM, data);
    },

    updateGym ({ commit }, data) {
        commit(types.UPDATE_GYM, data);
    },

    deleteGym ({ commit }, data) {
        commit(types.DELETE_GYM, data);
    },

    /**
     *
     * @param commit
     * @param userId
     * @return {Promise<void>}
     */
    getGyms ({ commit }, userId) {
        // Если стор уже заполнен
        if (state.all.length > 0) {
            return new Promise((resolve) => {
                setTimeout(() => resolve('Gyms have been retrieving already'), 20);
            })
        }

        return (new Request()).get('/gyms' + (userId ? '/?user_id=' + userId : ''))
            .then(response => {
                if (response.isSuccess()) {
                    const data = response.getData();
                    commit(types.ADD_GYMS, data);
                }
            })
    },

    getGymById ({ commit }, id) {
        if ((state.all.length > 0) === false) {
            return new Promise((resolve) => {
                setTimeout(() => resolve('Gyms have been retrieving already'), 20);
            })
        }

        let data = _.filter(
            state.all,
            function (gym) {
                if (gym.uuid) {
                    return gym.uuid === id;
                } else {
                    return gym.id === id;
                }
            });
        if (_.isArray(data)) {
            data = _.head(data);
        }
        commit(types.ADD_GYM_BY_ID, data);
    },

    getGymByName ({ commit }, data) {
        return (new Request()).post('/gyms/checking-web-name/', data)
            .then(response => {
                if (response.isSuccess()) {
                    const data = response.getData();
                    commit(types.CHECKING_GYM_NAME, data);
                }
            })
    }
};

// getters
export const getters = {
    /**
     *
     * @param state
     * @return {Array|*}
     */
    getGyms: state => state.all,
    getGymByName: state => state.searchedGym,
    getGymById: state => state.getGymById,
    getNewGym: state => state.getNewGym
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/gyms.js